<template>
  <!-- Loading State -->
  <div v-if="!requisicaoFinalizada" class="flex items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900">
    <div class="flex flex-col items-center gap-4">
      <div class="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
      <p class="text-sm text-gray-600 dark:text-gray-400">Carregando...</p>
    </div>
  </div>

  <!-- Main Content -->
  <div v-if="requisicaoFinalizada" class="min-h-screen bg-gray-50 dark:bg-gray-900">
    <!-- Header -->
    <header class="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div class="flex justify-between items-center">
          <!-- Logo -->
          <div class="flex-1"></div>
          <div class="h-8 w-auto flex-shrink-0">
            <img 
              src="@/assets/logoHeader.png" 
              v-if="nomeEmpresa == 'BRITECH' || nomeEmpresa == 'DNWAYS_DEMO_Y' || nomeEmpresa == 'DNWAYS_DEMO_X' || nomeEmpresa == 'DNWAYS'" 
              class="h-8 w-auto dark:brightness-200" 
              alt="Logo"
            />
            <img src="@/assets/dnways.png" v-if="nomeEmpresa == 'Vortex'" class="h-8 w-auto" alt="Logo" />
            <img src="@/assets/logoActual_v2.png" v-if="nomeEmpresa == 'ACTUAL'" class="h-8 w-auto" alt="Logo" />
            <img src="@/assets/logogenial.png" v-if="nomeEmpresa == 'GENIAL'" class="h-8 w-auto" alt="Logo" />
            <img src="@/assets/logoHeader_rji.png" v-if="nomeEmpresa == 'RJI'" class="h-8 w-auto" alt="Logo" />
          </div>
          
          <!-- Dark Mode Toggle -->
          <div class="flex-1 flex justify-end">
            <button
              @click="toggleTheme"
              class="p-2 rounded-lg bg-gray-100 dark:bg-slate-700 hover:bg-gray-200 dark:hover:bg-slate-600 transition-colors"
              aria-label="Toggle theme"
            >
              <!-- Ícone Sol (Light Mode) -->
              <svg
                v-if="!isDark"
                class="w-5 h-5 text-yellow-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
                  clip-rule="evenodd"
                />
              </svg>
              <!-- Ícone Lua (Dark Mode) -->
              <svg
                v-else
                class="w-5 h-5 text-slate-300"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </header>

    <!-- Container -->
    <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <!-- Documento Pendente para Assinatura -->
      <div v-if="situacaoDocumento != null && situacaoDocumento.Status == 'Pendente' && !situacaoDocumento.DataAssinatura" class="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700">
        <div class="p-6 sm:p-8">
          <!-- Título -->
          <div class="text-center mb-6">
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-2">
              <span v-if="this.user">Olá, {{ situacaoDocumento.NomeAssinante }}</span>
              <span v-else>Olá</span>
            </h2>
            <p class="text-gray-600 dark:text-gray-400">
              O documento abaixo está pendente para sua assinatura. Por favor, leia os termos e condições.
            </p>
          </div>

          <!-- Nome do Documento -->
          <div class="mb-6">
            <h3 class="text-xl font-medium text-gray-900 dark:text-gray-100 text-center">
              {{ situacaoDocumento.NomeDocumento }}
            </h3>
          </div>

          <!-- Container do Documento -->
          <div class="bg-gray-50 dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-700 p-6 mb-6 max-h-96 overflow-y-auto">
            <div class="prose dark:prose-invert max-w-none" v-html="conteudoTermosFormatado"></div>
          </div>

          <!-- Checkbox de Aceite -->
          <div class="flex items-center justify-center gap-3 mb-6 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-200 dark:border-blue-800">
            <Checkbox v-model="aceitoTermos" :binary="true" inputId="aceite" />
            <label for="aceite" class="text-sm font-medium text-gray-700 dark:text-gray-300 cursor-pointer">
              Declaro que li e aceito os termos do documento.
            </label>
          </div>

          <!-- Botão de Confirmação -->
          <div class="flex justify-center">
            <Button 
              label="Confirmar assinatura"
              :loading="disableBtnLogin"
              :disabled="!aceitoTermos || disableBtnLogin"
              @click="assinarDocumento"
              class="w-full sm:w-auto px-8"
              severity="primary"
            />
          </div>
        </div>
      </div>

      <!-- Documento Já Assinado -->
      <div v-if="mostrarCardAssinado" class="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700">
        <div class="p-6 sm:p-8">
          <!-- Status -->
          <div class="flex items-center justify-center gap-2 mb-6">
            <i class="pi pi-check-circle text-3xl text-green-600 dark:text-green-400"></i>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-gray-100">
              Documento já foi assinado
            </h2>
          </div>

          <!-- Meta Informações -->
          <div class="bg-gray-50 dark:bg-gray-900 rounded-lg p-4 mb-6 space-y-2">
            <div class="flex flex-col sm:flex-row sm:items-center gap-1">
              <span class="font-medium text-gray-700 dark:text-gray-300">Documento:</span>
              <span class="text-gray-900 dark:text-gray-100">{{ situacaoDocumento.NomeDocumento }}</span>
            </div>
            <div class="flex flex-col sm:flex-row sm:items-center gap-1">
              <span class="font-medium text-gray-700 dark:text-gray-300">Assinante:</span>
              <span class="text-gray-900 dark:text-gray-100">{{ situacaoDocumento.NomeAssinante }}</span>
            </div>
            <div class="flex flex-col sm:flex-row sm:items-center gap-1">
              <span class="font-medium text-gray-700 dark:text-gray-300">Data:</span>
              <span class="text-gray-900 dark:text-gray-100">{{ situacaoDocumento.DataAssinatura }}</span>
            </div>
          </div>

          <!-- Preview do Documento -->
          <div class="bg-gray-50 dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-700 p-6 max-h-96 overflow-y-auto">
            <div ref="docPreview" class="prose dark:prose-invert max-w-none" v-html="conteudoTermos"></div>
          </div>
        </div>
      </div>

      <!-- Documento Indisponível -->
      <div v-if="mostrarCardDocumentoInvalido" class="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700">
        <div class="p-6 sm:p-8">
          <div class="flex flex-col items-center justify-center gap-3 text-center">
            <i class="pi pi-exclamation-triangle text-5xl text-yellow-600 dark:text-yellow-400"></i>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-gray-100">
              Documento está indisponível para assinatura
            </h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/axios';
import { mapGetters } from 'vuex';
import Button from 'primevue/button';
import Checkbox from 'primevue/checkbox';
import { useTheme } from '@/composables/useTheme';
import {
    resolverTipoDocumentoAssinante,
    formatarConteudoTermos,
} from '@/utils/documentoUtils';
import { TIPO_CLIENTE } from '@/constants/TipoClienteEnum';

export default {
    name: 'ConfirmarConta',
    components: {
        Button,
        Checkbox
    },
    setup() {
        const { isDark, toggleTheme } = useTheme();
        return { isDark, toggleTheme };
    },
    computed: {
        ...mapGetters({
            situacaoDocumento: 'GET_SITUACAO_DOCUMENTO_ASSINATURA',
            PFInfoBasicas: 'GET_PF_INFO_BASICAS',
            listaProcuradoresPJ: 'GET_LISTA_PROCURADORES_PJ',
            user: 'auth/user'
        }),
        tipoDocumentoAssinante() {
            return resolverTipoDocumentoAssinante({
                nomeAssinante: this.situacaoDocumento?.NomeAssinante,
                emailAssinante: this.situacaoDocumento?.EmailAssinante,
                listaProcuradoresPJ: this.listaProcuradoresPJ,
                pfInfoBasicas: this.PFInfoBasicas,
            });
        },
        conteudoTermosFormatado() {
            return formatarConteudoTermos(
                this.conteudoTermos,
                this.tipoDocumentoAssinante,
            );
        }
    },
    data() {
        return {
            mostrarCardAssinado: false,
            mostrarCardDocumentoInvalido: false,
            aceitoTermos: false,
            nomeEmpresa: '',
            guidAssinatura: '',
            messageError: null,
            erro: false,
            disableBtnLogin: false,
            conteudoTermos: '',
            requisicaoFinalizada: false,
            isMobile: window.innerWidth <= 768
        };
    },
    mounted() {
        this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
        this.guidAssinatura = this.$route.params.id;
        this.$store.dispatch('FETCH_CONSULTA_ASSINANTE_DOCUMENTO', this.guidAssinatura);
        if (this.user?.TipoCliente === TIPO_CLIENTE.PESSOA_FISICA) {
            this.$store.dispatch('FETCH_PF_INFO_BASICAS');
        } else {
            this.$store.dispatch('FETCH_PJ_LISTA_PROCURADORES');
        }
        this.disableBtnLogin = false;

        window.addEventListener('resize', this.checkMobile);
    },
    
    beforeUnmount() {
        window.removeEventListener('resize', this.checkMobile);
    },
    watch: {
    situacaoDocumento() {
            this.requisicaoFinalizada = true;
            const s = this.situacaoDocumento;
            if (!s) return;

            if (s.Status === 'Pendente' && !s.DataAssinatura) {
                this.conteudoTermos = s.Conteudo;
                this.mostrarCardAssinado = false;

                return;
            }else if (s.Status === 'INATIVO') {
                this.mostrarCardAssinado = false;
                this.mostrarCardDocumentoInvalido = true;

                this.$swal({
                    icon: 'warning',
                    title: 'Atenção',
                    text: 'Documento está indisponível para assinatura.'
                });
                return;

            }
            else {
                this.conteudoTermos = s.Conteudo;
                this.mostrarCardAssinado = true;

                return;
            }

        }
    },
    methods: {
        checkMobile() {
            this.isMobile = window.innerWidth <= 768;
        },
        async getIpAddress() {
            try {
                const response = await fetch("https://api.ipify.org?format=json");
                const data = await response.json();
                return data.ip;
            } catch (error) {
                console.error("Error fetching IP address:", error);
                return null;
            }
        },
        async assinarDocumento() {
            if (this.disableBtnLogin) return;

            if (!this.aceitoTermos) {
                this.$swal({
                icon: 'warning',
                title: 'Atenção',
                text: 'Você precisa aceitar os termos antes de confirmar a assinatura.'
                });
                return;
            }

            const confirm = await this.$swal({
                icon: 'question',
                title: 'Confirmação de assinatura',
                text: 'Você confirma que leu e aceita os termos?',
                showCancelButton: true,
                confirmButtonText: 'Sim, assinar',
                cancelButtonText: 'Cancelar'
            });

            if (!confirm.isConfirmed) return;


            var ip = await this.getIpAddress();
            if (!ip) {
                console.error("Error fetching IP address:");
                this.$swal({
                            icon: 'error',
                            title: 'Oops...',
                            text: `Falha na validação da assinatura`,
                        });
            }
            this.disableBtnLogin = true;
            if (this.guidAssinatura == '') {
                this.messageError = 'Verifique os dados';
                this.erro = true;
                return;
            }
            var model = { Guid: this.guidAssinatura, Ip: ip }
            await api
                .post('/declaracao/assinar', model)
                .then((retorno) => {
                    this.disableBtnLogin = false;
                    if (!retorno.data) {
                        this.$swal({
                            icon: 'error',
                            title: 'Oops...',
                            text: `Falha na validação da assinatura`,
                        });
                    }
                    else {
                        this.$swal({
                            icon: 'success',
                            title: 'Documento assinado!',
                            text: `A assinatura foi realizada com sucesso!`,
                        });
                        this.$store.dispatch('FETCH_CONSULTA_ASSINANTE_DOCUMENTO', this.guidAssinatura);
                        
                        // Atualizar lista de documentos do cliente (SignalR não dispara evento)
                        this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS_CLIENTE');
                    }
                })
                .catch((error) => {
                    this.disableBtnLogin = false;
                    this.disableBtn = false;
                    this.$swal({
                        icon: 'error',
                        title: 'Oops...',
                        text: `${error.response.data.descricao}`,
                    });
                });
        },
        logoff() {
            this.$store.dispatch('auth/logout');
        },
    }
};

</script>

<style scoped>
/* Estilos customizados para o conteúdo HTML do documento */
.prose {
  @apply text-gray-700 dark:text-gray-300;
}

.prose :deep(h1),
.prose :deep(h2),
.prose :deep(h3),
.prose :deep(h4) {
  @apply text-gray-900 dark:text-gray-100 font-semibold;
}

.prose :deep(a) {
  @apply text-blue-600 dark:text-blue-400 hover:underline;
}

.prose :deep(strong),
.prose :deep(b) {
  @apply font-semibold text-gray-900 dark:text-gray-100;
}

.prose :deep(p) {
  @apply mb-4;
}

.prose :deep(ul),
.prose :deep(ol) {
  @apply ml-6 mb-4;
}

.prose :deep(li) {
  @apply mb-2;
}

/* Scrollbar customizada para dark mode */
.overflow-y-auto::-webkit-scrollbar {
  width: 8px;
}

.overflow-y-auto::-webkit-scrollbar-track {
  @apply bg-gray-100 dark:bg-gray-800 rounded;
}

.overflow-y-auto::-webkit-scrollbar-thumb {
  @apply bg-gray-300 dark:bg-gray-600 rounded;
}

.overflow-y-auto::-webkit-scrollbar-thumb:hover {
  @apply bg-gray-400 dark:bg-gray-500;
}
</style>
